// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    AiInferenceOperation,
    AiInferenceOperationFromJSON,
    AiInferenceOperationToJSON,
    AiKeyLimits,
    AiKeyLimitsFromJSON,
    AiKeyLimitsToJSON,
    AiTargetType,
    AiTargetTypeFromJSON,
    AiTargetTypeToJSON,
} from './';

/**
 * Support-managed policy for one use case. targetType=MODEL requires models and defaultModel and forbids agentId. targetType=AGENT requires agentId, forbids models/defaultModel, and requires operations=[CHAT_COMPLETIONS]. The server must reject missing or mixed target fields with 400, including on disabled profiles. These cross-field rules supplement schema validation.  MODEL may grant several direct models for an app-managed workflow; arrays are never empty because LiteLLM treats an empty model list as unrestricted. AGENT selects exactly one registered agent. Its resolved routing name is returned at key issuance, with no direct access to the agent\'s internal models or tools. A business can have multiple profiles of either type. Profiles do not create or modify models, agents, or upstream credentials. 
 * @export
 * @interface AiProfile
 */
export interface AiProfile {
    /**
     * Stable use-case identifier unique within this account and environment. Values such as basic and advanced are examples, not a closed list, and do not determine the target type.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiProfile
     */
    id: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiProfile
     */
    displayName: string;
    /**
     * User-facing explanation of this use case. Do not include prompts, patient data, or credentials.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiProfile
     */
    description?: string;
    /**
     * Whether new keys may be issued for this profile. Does not itself revoke existing keys.
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof AiProfile
     */
    enabled: boolean;
    /**
     * 
     * OpenAPI data type: {AiTargetType}
     * @type {AiTargetType}
     * @memberof AiProfile
     */
    targetType: AiTargetType;
    /**
     * Required only for MODEL; forbidden for AGENT. Exact non-agent model names, with no access-expanding aliases or groups.
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof AiProfile
     */
    models?: Array<string>;
    /**
     * Required only for MODEL and must occur in models; forbidden for AGENT configuration because the server resolves it from agentId. Select a compatible listed model per operation for mixed-capability MODEL profiles.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiProfile
     */
    defaultModel?: string;
    /**
     * Required only for AGENT; forbidden for MODEL. Select from GET /support/ai/agents in this environment. Profile access authorizes invocation, not agent administration or direct tool access.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiProfile
     */
    agentId?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<AiInferenceOperation>}
     * @memberof AiProfile
     */
    operations: Array<AiInferenceOperation>;
    /**
     * Used when issuance omits lifetimeSeconds. Must not exceed maxLifetimeSeconds; 900 seconds is the recommended initial value.
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof AiProfile
     */
    defaultLifetimeSeconds: number;
    /**
     * Maximum issuance lifetime; no profile may grant more than one hour. Clients renew before later requests. Expiry does not terminate a remote agent already executing.
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof AiProfile
     */
    maxLifetimeSeconds: number;
    /**
     * 
     * OpenAPI data type: {AiKeyLimits}
     * @type {AiKeyLimits}
     * @memberof AiProfile
     */
    keyLimits: AiKeyLimits;
}

export function AiProfileFromJSON(json: any): AiProfile {
    return {
            'id': json['id'],
            'displayName': json['displayName'],
            'description': !exists(json, 'description') ? undefined : json['description'],
            'enabled': json['enabled'],
            'targetType': AiTargetTypeFromJSON(json['targetType']),
            'models': !exists(json, 'models') ? undefined : json['models'],
            'defaultModel': !exists(json, 'defaultModel') ? undefined : json['defaultModel'],
            'agentId': !exists(json, 'agentId') ? undefined : json['agentId'],
            'operations': (json['operations'] as Array<any>).map(AiInferenceOperationFromJSON),
            'defaultLifetimeSeconds': json['defaultLifetimeSeconds'],
            'maxLifetimeSeconds': json['maxLifetimeSeconds'],
            'keyLimits': AiKeyLimitsFromJSON(json['keyLimits']),
    };

}

export function AiProfileToForm(value?: AiProfile): any {
    let jsonVal = AiProfileToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function AiProfileToJSON(value?: AiProfile): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'displayName': cleanupBlankValuesForBackend(value.displayName),
            'description': cleanupBlankValuesForBackend(value.description),
            'enabled': cleanupBlankValuesForBackend(value.enabled),
            'targetType': AiTargetTypeToJSON(value.targetType),
            'models': cleanupBlankValuesForBackend(value.models),
            'defaultModel': cleanupBlankValuesForBackend(value.defaultModel),
            'agentId': cleanupBlankValuesForBackend(value.agentId),
            'operations': (value.operations as Array<any>).map(AiInferenceOperationToJSON),
            'defaultLifetimeSeconds': cleanupBlankValuesForBackend(value.defaultLifetimeSeconds),
            'maxLifetimeSeconds': cleanupBlankValuesForBackend(value.maxLifetimeSeconds),
            'keyLimits': AiKeyLimitsToJSON(value.keyLimits),
    };
}


